import '@/components/RegionFilterVanilla';


document.addEventListener('DOMContentLoaded', function ()
{

});
